import { StyledInput } from "../ui";
import { media } from "../../../../../utils/uiSizes";

const Base = StyledInput.withComponent("textarea");
const StyledTextArea = Base.extend`
  resize: none;
  display: block;

  ${media.tablet`
    resize: vertical;
  `};
`;

export default StyledTextArea;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledTextArea.js